const Custom404 = () => {
    return <div className="inactive-store-wrapper">
        <div className="inactive-store-image NF-404-image">
            <img src={'/assets/Icons/page_not_found.png'} />
            <div>Page not found</div>
        </div>
    </div>
};

export default Custom404;
